import { render, staticRenderFns } from "./ModelVoyageChart.vue?vue&type=template&id=0cbd9101&scoped=true&"
import script from "./ModelVoyageChart.vue?vue&type=script&lang=js&"
export * from "./ModelVoyageChart.vue?vue&type=script&lang=js&"
import style0 from "./ModelVoyageChart.vue?vue&type=style&index=0&id=0cbd9101&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbd9101",
  null
  
)

export default component.exports